<script setup lang="ts">
import IcClock from '@/components/Icons/IcClock.vue'
import IcStraighten from '@/components/Icons/IcStraighten.vue'
import IcTotal from '@/components/Icons/IcTotal.vue'
import { markRaw } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  value: number | string
  label: string
}>()

const icons = {
  cycle_count: {
    icon: markRaw(IcTotal),
    class: 'h-9 w-9 text-gray',
  },
  total_time: {
    icon: markRaw(IcClock),
    class: 'h-9 w-9 text-gray',
  },
  average_time: {
    icon: markRaw(IcStraighten),
    class: 'h-9 w-9 text-gray',
  },
}

const getIcon = (label: string) => {
  return icons[label] || { icon: markRaw(IcTotal), class: 'h-9 w-9 text-gray' }
}
</script>

<template>
  <div class="grid min-h-[10.5rem] grid-flow-row bg-white px-6 py-6.5 shadow-md">
    <div class="flex flex-col items-start justify-start">
      <component :is="getIcon(props.label).icon" :class="getIcon(props.label).class" />

      <p class="py-3 text-title-lg font-bold text-black">
        {{ props.value }}
      </p>

      <p class="text-title-xsm2 font-medium text-gray-500">
        {{ t(`dashboard.body.mixing_cycle.cards.${props.label}`) }}
      </p>
    </div>
  </div>
</template>
